import { useTheme } from "@fluentui/react";
import * as React from "react";
// TODO: PBI #2567576: [PostFluent2Migration] Remove withTheme HOC
/**
 * HOC that injects the current theme into the component props
 * @deprecated withTheme HOC will be removed after Fluent v9 migration completion as passing theme props won't be necessary for applying themed styles to components.
 * @param Component Component to wrap
 */ export function withTheme(Component) {
    return function WrappedComponent(props) {
        const theme = useTheme();
        return /*#__PURE__*/ React.createElement(Component, {
            ...props,
            theme: theme
        });
    };
}
